import EmergencyContactForm from '../forms/emergencyContactForm';

export default function EmergencyContactModal({
  userId,
  onClose,
  onSaved,
}) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-label="Add emergency contacts"
        style={{ maxWidth: 760 }}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className="modal-title">Add Emergency Contacts</h2>
        <p className="text-muted" style={{ marginTop: 0, marginBottom: '1rem' }}>
          Add at least one emergency contact before you continue joining this club.
        </p>
        <EmergencyContactForm
          userId={userId}
          onSaved={onSaved}
          onCancel={onClose}
          hideHeading
          submitLabel="Save And Continue"
          showCancel
        />
      </div>
    </div>
  );
}
